<template>
  <div
    style="
      width: 100%;
      display: flex;
      justify-content: flex-end;
      font-size: 7px;
      font-family: Arial, Helvetica, sans-serif;
      margin-right: 15px;
      margin-left: 20px;
    "
  >
    <div style="align-self: center; font-weight: bold;">
      Feuille de présence de l’assemblée générale
      <span v-if="allowedModalities.physical || allowedModalities.video" class="font-weight-bold">
        {{ $moment(toLocalTime(meetingDate)).locale("fr").format("[le] DD MMMM YYYY [à] HH[h]mm") }}
      </span>
      <span v-else class="font-weight-bold">
        {{ $moment(toLocalTime(meetingDate)).locale("fr").format("[le] DD MMMM YYYY") }}
      </span>
      - <span>{{ meetingDetails.BuildingData.name }}</span>
      <div style="font-weight: normal;">
        Modalités de vote autorisées :
        <ul>
          <li v-if="allowedModalities.physical">Physique</li>
          <li v-if="allowedModalities.video">Visioconférence</li>
          <li v-if="allowedModalities.correspondence">Correspondance</li>
        </ul>
      </div>
    </div>
    <div style="border-left: 1px dotted #000; margin-left: 10px; padding-left: 10px;">
      <img :src="logoInBase64" alt="agency logo" height="35px" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["meetingDate", "logoInBase64", "allowedModalities"],
};
</script>
